import R from 'ramda';
import { createSelector } from 'reselect';
import { selectSection } from './section';
import { selectCurrentTerm } from 'selectors/terms';
import deprecated from '../deprecated';

import { param } from './utils';

const selectUserStoreRoot = root => root.current_user;

// This is a NOOP, but it's here to be more explicit about the fact that we
// don't want selectMarkupStoreRoot
// eslint-disable-next-line no-unused-vars
const selectRoot = root => root;

export const selectUser = createSelector(
    selectUserStoreRoot,
    state => state.user
);
export const getUser = deprecated(selectUser, `use selectUser instead`);

export const getPreferences = createSelector(
    selectUserStoreRoot,
    state => state.preferences
);

export const selectLastHighlightColor = createSelector(
    getPreferences,
    R.propOr('yellow', 'lastHighlightColor')
);
export const getLastHighlightColor = deprecated(
    selectLastHighlightColor,
    `use selectLastHighlightColor`
);

export const getNavPaginationTour = deprecated(
    createSelector(getPreferences, R.propOr(false, 'nav-pagination-tour')),
    `
nav-pagination-tour is a dead key.
If we ever need to reimplement a navigation tour it needs a unique name,
preferably referencing either when it was added or when it should stop being
used
`
);

export const isInstructorAnywhere = createSelector(
    selectUser,
    user => user.instructor_in.length > 0
);

// (state, section) => boolean
export const isInstructorInSection = createSelector(
    selectUser,
    param(1),
    (user, section) => {
        if (section == null || section.resource_uri == null) {
            return false;
        }

        return R.contains(section.resource_uri, user.instructor_in);
    }
);
export const isInstructorIn = deprecated(
    isInstructorInSection,
    `use isInstructorInSection instead. This function was depreacted because we have isInstructorInTerm`
);

export const isInstructorInTerm = createSelector(
    [selectCurrentTerm, app => app],
    ({ section_ids = [] }, root) => {
        const sections = section_ids
            .map(selectSection.bind(null, root))
            .filter(s => !!s);
        return sections.reduce((isInstructor, section) => {
            if (isInstructorInSection(root, section)) {
                return true;
            }
            return isInstructor;
        }, false);
    }
);

export const hideSharingQA = createSelector(
    selectUser,
    ({ hide_sharing_qa }) => hide_sharing_qa
);



// WEBPACK FOOTER //
// ./src/selectors/current_user.js